import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const user_editScreenModule = defineScreen({
  app: "coaching",
  screen_id: "user-edit",
  path: "/users/:user_id/edit",
  params: ["user_id"],
  heading: { text: "Edit user", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "deny",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "fill-valid", kind: "secondary", driver: "form.fillValid" },
    { id: "submit", kind: "primary", driver: "form.submit" },
    { id: "validation-error", kind: "secondary", driver: "form.validationError" }
  ],
  recipe: "Form-1",
  data: { seedNeeds: ["readonly-walk-session", "mutation-disposable-entity"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/user-edit.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default user_editScreenModule;
